package com.arena_web.pages.news.club

import androidx.compose.runtime.*
import com.arena_web.data.dto.TeamDetailDto
import com.arena_web.di.LocalAppContainer
import com.arena_web.ui.components.navigation.SidebarTab
import com.arena_web.ui.layouts.AppPageLayout
import com.arena_web.ui.sections.news.ClubDetailPageContent
import com.arena_web.ui.utils.isMobile
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext

// Club detail page — profile, form, history/calendar, squad. Reached from a
// team tap on the match detail page; the id is TheSportsDB's team id.
@Page("/news/club/{id}")
@Composable
fun ClubDetailPage() {
    val ctx = rememberPageContext()
    val mobile = isMobile()
    val repository = LocalAppContainer.current.newsRepository

    val teamId = ctx.route.path.substringAfterLast("/")
    val sport = org.w3c.dom.url.URLSearchParams(kotlinx.browser.window.location.search)
        .get("sport")?.takeIf { it.isNotBlank() } ?: "football"

    var team by remember(teamId) { mutableStateOf<TeamDetailDto?>(null) }
    var failed by remember(teamId) { mutableStateOf(false) }
    var playerId by remember { mutableStateOf<String?>(null) }
    LaunchedEffect(teamId) {
        val locale = com.arena_web.utils.Storage.get(com.arena_web.utils.StorageKeys.LANGUAGE)
        repository.getTeamDetail(sport, teamId, locale)
            .onSuccess { team = it }
            .onFailure { failed = true }
    }

    AppPageLayout(
        activeTab = SidebarTab.News,
        title = team?.name ?: "Club",
        mobileReady = true,
        mobileHideTopBar = true,
        mobileHideBottomNav = true,
        mobileEdgeToEdge = true,
    ) {
        ClubDetailPageContent(
            sport = sport,
            team = team,
            failed = failed,
            mobile = mobile,
            onOpenPlayer = { playerId = it },
        )
        playerId?.let { id ->
            com.arena_web.ui.sections.news.PlayerCardOverlay(
                sport = sport,
                playerId = id,
                mobile = mobile,
                onDismiss = { playerId = null },
            )
        }
    }
}
